// extracted by mini-css-extract-plugin
export default {"breadcrumb":"onrhbVYnmFZ76XI6c8hj","separator":"QXDPRUAhAr1gSSsdPYPt"};